import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApptRequestAlertPage } from './appt-request-alert.page';

const routes: Routes = [
  {
    path: '',
    component: ApptRequestAlertPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApptRequestAlertPageRoutingModule {}
